<template>
    <div class="checkout-success">
        <Navbar />

        <section>
            <div class="container">
                <div class="py-4">
                    <div class="alert alert-success">
                        <h4 class="alert-heading">Success!</h4>
                        <p class="m-0" v-if="order_number">
                            Your order has been placed. Your order number is: <strong>{{order_number}}</strong>
                            <br/><br/>
                            You will receive a confirmation email and details for online access within 24 hours.
                        </p>
                        <p class="m-0" v-else>
                            Thank you! Your order is being processed.
                        </p>
                    </div>
                    <div class="alert alert-warning small m-0 pb-0"><p v-if="isAdoptionOrder">
                        Print Teacher Editions are supplied only in the first year of multi-year print orders. Digital access remains available throughout the contract. Additional or replacement print TEs may be purchased by contacting adoptionsupport@studiesweekly.com.
                    </p>
                    </div>
                </div>
            </div>
        </section>

        <Footer />
    </div>
</template>

<style lang="scss">
@import "@/assets/scss/_colors.scss";

</style>

<style lang="scss">
@import "@/assets/scss/_colors.scss";

</style>

<script>
import { mapState } from 'vuex'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
    name: 'checkoutSuccess',
    data: () => ({
    }),
    components: {
        Navbar,
        Footer
    },
    computed: {
        ...mapState({
             products: state => state.cart.products,
            lastOrder: state => state.checkout.lastOrder,
        }),
        isAdoptionOrder() {
            if (!this.lastOrder)
                return false;

            return this.lastOrder.multiyear > 1;
        }
    },
    props: ['order_number'],
    methods: {

    },
    mounted () {

    }
}
</script>
